import {ProductApi} from "@core/api";
import {ProductIdentifiers, ProductNames, getNameOrId} from "@/libs/product";

export default {
    data() {
        return {
            attributes: null,
        };
    },
    methods: {
        getProductAttributeTitle(attributeType, key) {
            if (this.attributes) {
                return this.attributes[attributeType].find(a => a.key === key).title;
            }

            return '';
        },

        getProductName(names, key) {
            return getNameOrId(names, key || ProductNames.OUR_PRODUCT_NAME);
        },

        getProductId(identifiers, key) {
            return getNameOrId(identifiers, key || ProductIdentifiers.PRODUCT_ID);
        },

        getNameLabel(key) {
            if (this.attributes) {
                return this.getProductAttributeTitle('ProductName', key || ProductNames.OUR_PRODUCT_NAME);
            }

            return 'Loading...';
        },

        getIdentifierLabel(key) {
            if (this.attributes) {
                return this.getProductAttributeTitle('ProductId', key || ProductIdentifiers.PRODUCT_ID);
            }
            return 'Loading...';
        }
    },

    computed: {
        supplierNameLabel() {
            return this.getNameLabel(ProductNames.SUPPLIERS_PRODUCT_NAME);
        },

        supplierIdLabel() {
            return this.getIdentifierLabel(ProductIdentifiers.SUPPLIERS_PRODUCT_ID);
        },

        productNameLabel() {
            return this.getNameLabel();
        },

        productIdLabel() {
            return this.getIdentifierLabel();
        },

        scipNameLabel() {
            return this.getNameLabel(ProductNames.SCIP_NAME);
        },

        scipNumberLabel() {
            return this.getIdentifierLabel(ProductIdentifiers.SCIP_NUMBER)
        },
    },

    created() {
        ProductApi.getAttributes().then(r => {
            this.attributes = r.data
        });
    },
}
